// extracted by mini-css-extract-plugin
export default {"xxSmall":"styles_xxSmall__cw7Dw"};